export default "/static/baf88e224766ff3ef06b01b071d6a976593a2da1/frontend/86f37156fb08c0c498ede517163d9d77.svg";